export var AfriexReferralStatus;
(function (AfriexReferralStatus) {
    AfriexReferralStatus["Joined"] = "joined";
    AfriexReferralStatus["Transacted"] = "transacted";
    AfriexReferralStatus["Qualified"] = "qualified";
    AfriexReferralStatus["Resolved"] = "resolved";
})(AfriexReferralStatus || (AfriexReferralStatus = {}));
//# sourceMappingURL=AfriexReferralStatus.js.map